import { FormattedMessage } from 'react-intl';

export const RequireProofOfIdentityLabel = () => (
    <FormattedMessage
        id='platform.wizard.proof_of_identity.require_proof_of_identity_short'
        description='Short checkbox label for enabling proof-of-identity requirements in the platform wizard'
        defaultMessage='Require proof of identity'
    />
);

export const DropOffProofOfIdentityHelpMessage = () => (
    <FormattedMessage
        id='platform.wizard.proof_of_identity.drop_off_help'
        description='Help text explaining the proof-of-identity checkbox for a drop-off in the platform wizard'
        defaultMessage='When enabled, the person dropping off the package must prove their identity with Itsme, QR-code, or employee badge.'
    />
);

export const PickUpProofOfIdentityHelpMessage = () => (
    <FormattedMessage
        id='platform.wizard.proof_of_identity.pick_up_help'
        description='Help text explaining the proof-of-identity checkbox for a pick-up in the platform wizard'
        defaultMessage='When enabled, the person picking up the package must prove their identity with Itsme, QR-code, or employee badge.'
    />
);
